const Edit = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 11 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5577 0.963567C9.42368 0.830116 9.26455 0.724542 9.08949 0.652943C8.91444 0.581344 8.72694 0.545139 8.53781 0.54642C8.34869 0.5477 8.16169 0.58644 7.98762 0.660403C7.81355 0.734365 7.65587 0.842084 7.52367 0.977337L2.12359 6.37749C1.92415 6.57693 1.78198 6.82631 1.71194 7.09953L1.25461 8.88367C1.1952 9.11546 1.40592 9.32616 1.63771 9.26671L3.42194 8.80908C3.69509 8.73902 3.94439 8.59686 4.14378 8.39747L9.54393 2.99724C9.67922 2.8651 9.78697 2.70745 9.86095 2.53341C9.93494 2.35937 9.97369 2.17238 9.97497 1.98327C9.97625 1.79416 9.94004 1.60668 9.86841 1.43165C9.79679 1.25662 9.69118 1.09753 9.5577 0.963567Z"
        fill="#AEB9E1"
        stroke="#AEB9E1"
        strokeWidth="0.786884"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Edit;
